<template>
  <div>
    <!-- 批量导入 -->
    <dialog-wrap-upgrade
      ref="batchImport"
      :configOptions="configOptions"
      @close="closeBox"
    >
      <template #uploadMI>
        <el-upload
          class="upload-demo ml"
          action=""
          :limit="1"
          :http-request="(files)=>{uploadRequest(files,POLICY)}"
          :before-upload="checkFileType"
          :autoUpload="true"
          :file-list="fileList2"
          :show-file-list="false"
          :disabled="upPolicyLoading[POLICY]"
          v-if="judgePermission('vehicle_insurance_policy_list_batch_create')"
          v-show="false"
        >
          <el-button ref="uploadMI">导入保单记录</el-button>
        </el-upload>
        <el-button type="primary" size="small" :loading="upPolicyLoading[POLICY]" @click="validateForm('uploadMI')">导入保单记录</el-button>
      </template>
      <template #uploadMIList>
        <el-upload
          class="upload-demo ml"
          action=""
          :limit="1"
          :http-request="(files)=>{uploadRequest(files,STOP_OR_RESUME_POLICY)}"
          :autoUpload="true"
          :file-list="fileList2"
          :show-file-list="false"
          :disabled="upPolicyLoading[STOP_OR_RESUME_POLICY]"
          :before-upload="checkFileType"
          v-if="judgePermission('vehicle_insurance_policy_list_batch_create')"
          v-show="false"
        >
          <el-button ref="uploadMIList">导入停复保信息</el-button>
        </el-upload>
        <el-button type="primary" size="small" :loading="upPolicyLoading[STOP_OR_RESUME_POLICY]" @click="validateForm('uploadMIList')">导入停复保信息</el-button>
      </template>
    </dialog-wrap-upgrade>
    <!-- 导入失败提示 -->
    <dialogWrap
      v-model="uploadDialogShow"
      title="导入失败提示"
      :width="'750px'"
      class="spring-frame"
      :before-close="beforeUploadClose"
    >
      <p v-for="(item, index) in uploadTableData" :key="index" style="margin-bottom: 8px">
        {{ item }}
      </p>
    </dialogWrap>
  </div>
</template>
<script>
import { getHead } from '@/utils'
import axios from 'axios'
import { insurancePolicyTemplate, policyStopOrResumeTemplate } from '@/config'
import { uploadTaskCreate } from '@/api/currencyApi.js'

export default {
  data() {
    return {
      uploadTableData: [],
      uploadDialogShow: false, // 导入失败提示弹窗
      fileList2: [],
      // 导入功能弹框配置信息
      configOptions: {
        attrs: {
          title: '批量保单维护',
          width: '1000px',
          closeOnClickModal: false,
        },
        contentConfig: {
          title:
            '这个功能的前提是，您已经制作了一张目标表单希望直接将Excel转移到系统，若没有制作，请点击下方模板下载按钮',
          describes: [
            '导入前准备:',
            '1.请使用标准模板，确认未进行过任何更改，若无意中修改了模板的原有内容，建议重新下载模板；',
            '2.确保Excel中标题行的名称和表单中与之对应的字段标题一致，且表单中字段名称不能相同；',
            '3.确保Excel中数据没有任何颜色样式，否则将与导入功能的错误提示混淆；',
            '4.确保Excel中数据格式正确。比如手机号码格式为11位的大陆手机号，日期格式为2020-01-01，日期与数字格式的数据均不能含有中文；',
            '5.如果表单中有设置必填项字段，在Excel中对应的列下，都必须有数据/值；',
            '6.Excel多余的列无法导入，请删除Excel中不需要导入的列',
          ],
        },
        footerList: [
          { slotName: 'uploadMI' },
          { slotName: 'uploadMIList' },
          {
            text: '下载保单记录模板',
            isShowBtn: () => {
              this.judgePermission('vehicle_insurance_policy_list_batch_create')
            },
            click: () => {
              this.download('insurancePolicyTemplate')
            },
            options: {
              type: 'primary',
              class: 'ml',
            },
          },
          {
            text: '下载停复保信息模板',
            isShowBtn: () => {
              this.judgePermission('vehicle_insurance_policy_list_batch_create')
            },
            click: () => {
              this.download('policyStopOrResumeTemplate')
            },
            options: {
              type: 'primary',
              class: 'ml',
            },
          },
        ],
      },
      POLICY: 51, // 保险信息
      STOP_OR_RESUME_POLICY: 52, // 停复保信息
      upPolicyLoading: {
        51: false,
        52: false,
      }, // 上传中不可上传
      codeDict: {
        51: 'vehicle_guarantee_slip_file',
        52: 'vehicle_maintenance_guarantee_slip_file',
      },
    }
  },
  methods: {
    // 关闭导入弹窗
    closeBox() {
      this.upPolicyLoading = {
        POLICY: false,
        STOP_OR_RESUME_POLICY: false,
      } // 上传中不可上传
      this.fileList2 = []
    },
    // 下载逻辑
    download(type) {
      const downloadData = { insurancePolicyTemplate, policyStopOrResumeTemplate }
      window.location.href = downloadData[type]
    },
    // 导入车辆
    // eslint-disable-next-line vue/no-unused-properties
    uploadPolicy() {
      this.$refs.batchImport.showDialog()
    },
    /* 自定义上传 */
    uploadRequest({ file }, type) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('group', 'vehicle')
      formData.append('code', this.codeDict[type])
      axios({
        url: '/admin/v1/vehicle/fs/standard/upload',
        method: 'POST',
        data: formData,
        headers: {
          ...this.headers,
          ...getHead(this.$store),
        },
        onUploadProgress: () => {
          this.upPolicyLoading[type] = true
        },
      }).then(({ data: { code, data } }) => {
        if (code === 1) {
          const params = {
            fileAddress: data,
            uploadType: type,
            fileName: file.name,
          }
          // type 50保单信息导入/51保单停复保导入
          uploadTaskCreate(params).then((res) => {
            if (res.code === 1) {
              this.$message({
                message: '导入成功',
                type: 'success',
              })
              this.$refs.batchImport.close()
              this.$emit('upSuccess')
            } else if (res.code === 23023) {
              if (res.data && res.data.length > 0) {
                this.uploadTableData = res.data || []
                this.uploadDialogShow = true
              }
            }
          })
        }
        this.fileList2 = []
        this.upPolicyLoading[type] = false
      }).catch(() => {
        this.upPolicyLoading[type] = false
        this.fileList2 = []
      })
    },
    // 检查文件类型
    checkFileType(file) {
      // xlsx，xls
      const isXls = file.name.endsWith('xlsx') || file.name.endsWith('xls')
      if (!isXls) {
        this.$message.error('文件只能是 xlsx、xls格式!')
      }
      return isXls
    },
    beforeUploadClose() {
      this.uploadTableData = []
      this.uploadDialogShow = false
    },
    validateForm(refName) {
      this.$refs[refName].$el.click()
    },
  },
}
</script>
